import React, {Component} from 'react'

import styled from '@emotion/styled'
import StyleVariales from '../styles/marketing'

// STYLE ##########################################################

const sv = StyleVariales;

const Auth = styled(`div`)`
  flex: 1;
  ${sv.flexCenter};
  margin-bottom: 20px;
`;

const Container = styled(`div`)`
  flex: 1;
  max-width: ${props => props.maxWidth ? props.maxWidth : '400px'}; 
`;

const Title = styled(`div`)`
  ${sv.h1};
  color: ${sv.colors.headline};
  margin-bottom: 32px;
`;

const FormContainer = styled(`div`)`
  padding: 24px;
  background: ${sv.colors.light};
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0,0,0,.25);
  width: 100%;

  ${sv.box};
`;

// COMPONENT ##########################################################

class AuthBase extends Component {

  render() {
    return (
      <Auth>
        <Container maxWidth={this.props.maxWidth}>
          <Title>{this.props.title}</Title>
          <FormContainer>
            {this.props.children}
          </FormContainer>
        </Container>
      </Auth>
    )
  }

}

export default AuthBase
